import { useMutation } from '@tanstack/react-query';
import { api } from '../../../../services/api';

interface DropboxAuthResult {
  accessToken: string;
  userId: string;
}

export function useDropboxAuthUrl() {
  return useMutation({
    // Endpoint returns the URL as a plain-text body (not JSON), so read it as text.
    mutationFn: () => api.getText('/oauth/dropbox/authorization/url'),
  });
}

export function useDropboxAuthToken() {
  return useMutation({
    mutationFn: ({ state, code }: { state: string; code: string }) => {
      const qs = new URLSearchParams({ state, code });
      return api.get<DropboxAuthResult>(`/oauth/dropbox/authorization/token?${qs}`);
    },
  });
}
